var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import PictureCollectionUpload from '@declaration/components/upload/PictureCollectionUpload.vue';
import { ClaimFileType } from '@shared/types/file';
const externalDamage = namespace('externalDamage');
const settings = namespace('settings');
const qualification = namespace('qualification');
let ExternalDamagePictures = class ExternalDamagePictures extends Vue {
    constructor() {
        super(...arguments);
        this.ClaimFileType = ClaimFileType;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get externalDamage() {
        return this.change.data;
    }
    get pictureCollection() {
        return this.externalDamage.pictureCollection;
    }
    get requiredPhotosCount() {
        if (!this.setting)
            return 0;
        const trigram = this.trigram;
        if (!trigram)
            return 0;
        let rawValue = null;
        try {
            rawValue = this.setting(`damageRequiredPhotosCount${trigram}`);
        }
        catch (_a) {
            rawValue = null;
        }
        if (rawValue === undefined || rawValue === null) {
            try {
                const groupedSetting = this.setting('damageRequiredPhotosCount');
                if (groupedSetting && typeof groupedSetting === 'object') {
                    rawValue = groupedSetting[trigram];
                }
            }
            catch (_b) {
                rawValue = null;
            }
        }
        const value = Number(rawValue);
        return isNaN(value) ? 0 : value;
    }
    get isPhotoRequirementMet() {
        var _a, _b, _c;
        if (this.requiredPhotosCount === 0) {
            return true;
        }
        const collection = this.pictureCollection;
        if (!collection || typeof collection === 'string')
            return false;
        const files = (_c = (_a = collection.uploadedAppFiles) !== null && _a !== void 0 ? _a : (_b = collection.data) === null || _b === void 0 ? void 0 : _b.uploadedAppFiles) !== null && _c !== void 0 ? _c : [];
        return files.length >= this.requiredPhotosCount;
    }
    onPictureCollectionUpdate(pictureCollection) {
        this.updateDamage({ changeKey: this.changeKey, data: { pictureCollection } });
        const isValid = this.isPhotoRequirementMet;
        this.$nextTick(() => {
            this.$emit('update:photos-valid', isValid);
        });
    }
    mounted() {
        const isValid = this.isPhotoRequirementMet;
        this.$emit('update:photos-valid', isValid);
    }
};
__decorate([
    externalDamage.Getter('change')
], ExternalDamagePictures.prototype, "changeGetter", void 0);
__decorate([
    externalDamage.Action('updateDamage')
], ExternalDamagePictures.prototype, "updateDamage", void 0);
__decorate([
    settings.Getter('setting')
], ExternalDamagePictures.prototype, "setting", void 0);
__decorate([
    qualification.Getter('typeTrigram')
], ExternalDamagePictures.prototype, "trigram", void 0);
ExternalDamagePictures = __decorate([
    Component({
        components: {
            PictureCollectionUpload,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            validateRequested: { type: Boolean, default: false },
        },
    })
], ExternalDamagePictures);
export default ExternalDamagePictures;
